var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5003 2.79688V5.64688C12.5003 6.17155 12.948 6.59687 13.5003 6.59687H16.5003M7.00031 15.1469V11.3469M10.0003 15.1469L10.0003 7.54687M13.0003 15.1469V11.3469M15.0003 4.22187C14.5552 3.84357 14.0934 3.39488 13.8019 3.10347C13.6078 2.90956 13.3398 2.79688 13.0582 2.79688H5.50008C4.39551 2.79688 3.50008 3.64753 3.50008 4.69686L3.5 16.0968C3.49999 17.1462 4.39542 17.9968 5.49999 17.9968L14.5 17.9969C15.6046 17.9969 16.5 17.1462 16.5 16.0969L16.5003 6.02516C16.5003 5.78224 16.4028 5.54874 16.2253 5.37385C15.8971 5.05047 15.3491 4.51837 15.0003 4.22187Z",
    stroke: "#6F6F6F",
    strokeWidth: 1.68315,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportIcon);
export default __webpack_public_path__ + "static/media/ReportIcon.0e4ea0b6205ffefa2b4b47d1b73ad932.svg";
export { ForwardRef as ReactComponent };